module.exports = __webpack_public_path__ + "img/arrows-repeat.b9a91e90.svg";